var map = {
	"./avau-arbeitsplatten/Main.vue": [
		"3Xpl",
		2
	],
	"./duschking-konfigurator/Main.vue": [
		"3Zzm",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "NSF+";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/customer lazy ^\.\/.*\/Main\.vue$
// module id = NSF+
// module chunks = 12